@if (bulletPoints) {
  <h3>{{ 'productDetails.productKeyFeatures.title' | transloco }}</h3>
  <ul class="key-features__list">
    @for (bulletPoint of bulletPoints; track bulletPoint) {
      @if (bulletPoint?.text; as bulletPointText) {
        <li>
          <fa-icon [icon]="faCheck" class="small"></fa-icon>
          {{ bulletPointText }}
        </li>
      }
    }
  </ul>
}
